export default __webpack_public_path__ + "static/media/notification-requests.d4959299.svg";